import { openSnackbar } from "../components/notifier";

export default function notify(obj) {
  openSnackbar({ message: obj.text || obj.toString() });
}
